var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('NewModalComponent',{ref:"modalNewPayment",attrs:{"overflowContent":""}},[_c('PaymentForm',{ref:"formPayment",attrs:{"paymentId":0},on:{"created":_vm.createdPayment,"close":_vm.close}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }